// extracted by extract-css-chunks-webpack-plugin
module.exports = {"add":"_3pysw","addIcon":"_3w0-X"};